export const STATUS_COLORS = {
  unmatched: "default",
  suggested: "gold",
  matched: "green",
  split: "green",
  ignored: "purple"
};

export const STATUS_LABELS = {
  unmatched: "Open",
  suggested: "Suggested",
  matched: "Matched",
  split: "Split",
  ignored: "Ignored"
};

export const BATCH_STATUS_COLORS = {
  draft: "default",
  generated: "blue",
  uploaded: "gold",
  executed: "green",
  cancelled: "red"
};

export const MATCH_TYPE_LABELS = {
  invoice: "Invoice",
  beleg: "Supplier invoice",
  payroll_run: "Payroll run",
  filing: "Tax filing",
  account: "Account",
  transfer: "Transfer",
  private: "Private",
  fee: "Bank fee"
};

export const KIND_LABELS = {
  current: "Current account",
  credit_card: "Credit card",
  paypal: "PayPal",
  savings: "Savings",
  loan: "Loan"
};

export const PROVIDER_LABELS = {
  manual: "Manual",
  csv: "CSV import",
  camt: "CAMT import",
  finapi: "finAPI",
  gocardless: "GoCardless",
  fints: "FinTS"
};
